import React from 'react';
import { Card, CardBody } from '@edgebox/react-components';
import { JsonView, collapseAllNested } from 'react-json-view-lite';

import { jsonStyle } from '../../../../Helpers';
import type { FormulaConfigResponse } from '@edgebox/sync-core-rest-client/dist/services/api';

export function FormulaRegistryTab(props: { config: FormulaConfigResponse }) {
  const { config } = props;

  return (
    <Card className="mt-2">
      <CardBody>
        <div className="fw-bold">Allowed categories</div>
        <div className="mt-2">
          <JsonView data={config.allowedCategories ?? []} style={jsonStyle} shouldExpandNode={collapseAllNested} />
        </div>

        <div className="fw-bold mt-3">Limits</div>
        <div className="mt-2">
          <JsonView data={config.limits} style={jsonStyle} shouldExpandNode={collapseAllNested} />
        </div>

        <div className="fw-bold mt-3">Types</div>
        <div className="mt-2">
          <JsonView data={config.types} style={jsonStyle} shouldExpandNode={collapseAllNested} />
        </div>

        <div className="fw-bold">Variables</div>
        <div className="mt-2">
          <JsonView data={config.variables} style={jsonStyle} shouldExpandNode={collapseAllNested} />
        </div>

        <div className="fw-bold mt-3">Functions</div>
        <div className="mt-2">
          <JsonView data={config.functions} style={jsonStyle} shouldExpandNode={collapseAllNested} />
        </div>

        <div className="fw-bold mt-3">Operators</div>
        <div className="mt-2">
          <JsonView data={config.operators} style={jsonStyle} shouldExpandNode={collapseAllNested} />
        </div>
      </CardBody>
    </Card>
  );
}
